(() => {
  window.swinger.observer.initialize('[data-tooltip][title],[data-tooltip][aria-label],[data-tooltip][aria-description]', (elem) => {
    elem.setAttribute('tabindex', '0');

    if (!window.matchMedia('(hover: hover)').matches) {
      return;
    }

    if (elem.hasAttribute('title')) {
      elem.setAttribute('aria-label', elem.getAttribute('title'));
      elem.removeAttribute('title');
    }

    window.setTimeout(() => {
      switch (true) {
        default:
        case window.swinger.pseudoElementTracker.hasElemBeforePseudo(elem):
          elem.classList.add('swinger-data-tooltip--use-after-pseudo');
          break;

        case window.swinger.pseudoElementTracker.hasElemAfterPseudo(elem):
          elem.classList.add('swinger-data-tooltip--use-after-pseudo');
          break;
      }
    }, 50);
  });
})();
